import React from 'react';
import { Link } from 'react-router-dom';

export function SitemapPageContent() {
  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Sitemap</h1>

      <ul className="list-disc list-inside space-y-2">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About HDRL</Link></li>
        <li><Link to="/dataset/ACE_SWEPAM_L2_PT64S">Dataset</Link></li>
        <li><Link to="/search/solar%20wind/1">Search Page</Link></li>
        <li><Link to="/mission/MMS">Missions</Link></li>
        <li><Link to="/missionlist">Mission List</Link></li>
        <li><Link to="/region/sun">Region</Link></li>
        <li><Link to="/learn-about-helio">Learn about Heliophysics</Link></li>
        <li><Link to="/where-it-comes-from">Where It Comes From</Link></li>
        <li><Link to="/downloading-and-acquiring">Discover and Download Data</Link></li>
      </ul>
    </div>
  );
};
